import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          更新快报
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          实时追踪最新漫画更新动态，绝不错过任何精彩
        </p>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 before:absolute before:left-[7px] before:top-2 before:bottom-2 before:w-0.5 before:bg-gradient-to-b before:from-primary-300 before:via-primary-200 before:to-background-200">
            {updateItems.map((item, i) => (
              <div key={i} className="relative mb-7 last:mb-0">
                <div className={`absolute -left-[25px] top-0.5 w-[14px] h-[14px] rounded-full border-2 border-background-100 ${
                  i === 0 ? 'bg-primary-500 shadow-[0_0_0_4px_rgba(var(--primary-500),0.15)]' : 'bg-background-300'
                }`} />
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className={`text-xs font-medium px-2 py-0.5 rounded whitespace-nowrap ${
                    item.tag === '日漫' ? 'bg-primary-100 text-primary-700' :
                    item.tag === '韩漫' ? 'bg-accent-100 text-accent-700' :
                    'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-1 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}